import React from 'react';
import PropTypes from 'prop-types';
import { InputNumber } from 'rsuite';
import { FaPlus, FaMinus } from 'react-icons/fa';
import { IconContext } from 'react-icons';

function NumberInput(props) {

  function renderComponent(typeId) {
    switch (typeId) {
      case 1:
        let selectorClass = "text-xs p-2 bg-white border border-gray-700 rounded-lg hover:bg-blue-700 hover:text-white disabled:opacity-50 focus:outline-none ";

        return <React.Fragment>
          {<label className={props.labelClass} htmlFor="{props.id}">{props.label}</label>}
          <div className="flex items-center">
            <button disabled={props.min >= props.value} className={selectorClass}
              onClick={() => { props.onChange(props.name, props.value - props.step) }}>
              <IconContext.Provider value={{ size: "0.75em" }}>
                <FaMinus />
              </IconContext.Provider>
            </button>
            <span className="text-base px-2 w-8 text-center">{props.value}</span>
            <button disabled={props.max <= props.value} className={selectorClass}
              onClick={() => { props.onChange(props.name, props.value + props.step) }}>
              <IconContext.Provider value={{ size: "0.75em" }}>
                <FaPlus />
              </IconContext.Provider>
            </button>
          </div>
        </React.Fragment>
        break;
      case 0:
      default:
        return <React.Fragment>
          {<label className={props.labelClass} htmlFor="{props.id}">{props.label}</label>}
          <InputNumber className={props.numberInputClass}
            id={props.id}
            name={props.name}
            min={props.min || 0}
            step={props.step}
            value={props.value}
            onChange={(e) => { props.onChange(props.name, e) }}
          />
        </React.Fragment>
        break;
    }
  }

  return (
    <div className={props.wrapperClass} >
      {renderComponent(props.typeId)}
      {props.error.length > 0 && <div className="alert alert-danger">{props.error}</div>}
    </div>
  );
}


// Define what props this element has (for debugging purposes only)
NumberInput.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  min: PropTypes.number,
  step: PropTypes.number,
  value: PropTypes.number,
  error: PropTypes.string
}

NumberInput.defaultProps = {
  error: "",
  value: 0,
  typeId: 0,
  step: 1,
}


export default NumberInput;